import { FC } from 'react'
import CustomSelect from '../../UI/CustomSelect/CustomSelect'
import CustomInput from '../../UI/CustomInput/CustomInput'
import styles from '../EditClaimCardMainInformation.module.css'
import {
  paymentStatus,
  claimsStatuses,
  rejectionCauses,
  paymentType,
} from '../../../constants/constants'

interface StatusAndPaymentSectionProps {
  values: any
  handleChange: any
  setFieldValue: (field: string, value: any) => void
}

export const StatusAndPaymentSection: FC<StatusAndPaymentSectionProps> = ({
  values,
  handleChange,
  setFieldValue,
}) => {
  return (
    <div className={styles.sectionBlock}>
      <div className={styles.sectionTitle}>Статус и оплата</div>
      <div className={styles.sectionContent}>
        <div className={styles.statusBlock}>
          <div className={styles.leftBlock}>Статус</div>
          <div className={styles.rightDateBlock}>
            <CustomSelect
              name='status'
              options={claimsStatuses}
              value={values.status}
              onChangeOption={(option) => {
                const newStatus = option?.trim()
                setFieldValue('status', newStatus)
                const normalizedStatus = newStatus?.toLowerCase()
                const isCancelled = normalizedStatus === 'отменена'
                if (isCancelled) {
                  const firstRejection = rejectionCauses?.[0] || null
                  setFieldValue('rejectionCause', firstRejection)
                } else if (values.rejectionCause) {
                  setFieldValue('rejectionCause', null)
                }
              }}
            />
          </div>
        </div>

        {values.status?.toLowerCase().trim() === 'отменена' && (
          <div className={styles.statusBlock}>
            <div className={styles.leftBlock}>Причина отмены</div>
            <div className={styles.rightDateBlock}>
              <CustomSelect
                name='rejectionCause'
                options={rejectionCauses}
                value={values.rejectionCause}
                onChangeOption={(option) => setFieldValue('rejectionCause', option)}
              />
            </div>
          </div>
        )}

        <div className={styles.statusBlock}>
          <div className={styles.leftBlock}>Оплачено</div>
          <div className={styles.rightDateBlock}>
            <CustomSelect
              name='paymentStatus'
              options={paymentStatus}
              value={values.paymentStatus}
              onChangeOption={(option) => setFieldValue('paymentStatus', option)}
            />
          </div>
        </div>

        <div className={styles.statusBlock}>
          <div className={styles.leftBlock}>Вид оплаты</div>
          <div className={styles.rightDateBlock}>
            <CustomSelect
              name='paymentType'
              options={paymentType}
              value={values.paymentType}
              onChangeOption={(option) => setFieldValue('paymentType', option)}
            />
          </div>
        </div>

        {values.paymentStatus === 'Частично оплачено' && (
          <div className={styles.statusBlock}>
            <div className={styles.leftBlock}>Введите сумму предоплаты</div>
            <div className={styles.rightDateBlock}>
              <CustomInput
                value={values.prepaymentAmount}
                onChange={handleChange('prepaymentAmount')}
                placeholder='Введите сумму предоплаты'
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
